import React from 'react';
import { connect } from 'react-redux';
import {
  grossProfitPageRequest,
  changeDateGrossProfit,
  changeOutletGrossProfit,
  exportGrossProfit,
} from 'actions/reports/sales';
import { csvName } from 'utils/formatterCsvName';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import LoadingSpinner from 'components/LoadingSpinner';
import * as clevertapReportsGrossProfit from 'clevertap/reports/grossProfit';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import withFeatureFlags from 'hocs/withFeatureFlags';
import ActionBar from '../ActionBar';
import styles from './GrossProfit.css';
import BodyFrame from '../BodyFrame';
import GrossProfitReportTable from './GrossProfitReportTable';

const exportMenus = [
  {
    display: 'Gross Profit Per Outlet',
    key: 'perOutlet',
    id: 'export-per-outlet',
  },
  {
    display: 'Gross Profit',
    key: 'grossProfit',
  },
];

class GrossProfit extends React.Component {
  componentDidMount() {
    this.props.grossProfitPageRequest();
  }

  render() {
    const {
      outlets,
      search,
      location,
      outletComparisonEnabled,
      showLoadingSpinnerReport,
      grossProfit,
    } = this.props;
    const hasMultipleOutlets = outlets && outlets.length > 1;
    const oneOutletSelected = search.outlet && search.outlet.length === 1;

    return (
      <div id="reports-sales-gross-profit" className={styles.wrapper}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
          exportMenus={
            hasMultipleOutlets && oneOutletSelected && outletComparisonEnabled
              ? exportMenus
              : []
          }
        />
        <BodyFrame location={location}>
          <div className={styles['table-wrapper']}>
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            <div className={`${styles.header_panel} panel panel-default`}>
              <div className="panel-body">
                <h5 className={styles.thickTitle}>Gross Profit</h5>
                <p>
                  Gross Profit is your Net Sales minus Cost of Goods Sold
                  (COGS).{' '}
                  <strong>
                    To report gross profit accurately, please make sure all
                    items have a COGS.
                  </strong>
                </p>
              </div>
            </div>
            {!showLoadingSpinnerReport && (
              <GrossProfitReportTable grossProfitReport={grossProfit} />
            )}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _onChangeOutlet = (outletIds = []) => {
    const { changeOutletGrossProfit, search } = this.props;
    const { startDate, endDate, startHour, endHour, allDay } = search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    changeOutletGrossProfit({
      outletIds,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { changeDateGrossProfit, search } = this.props;
    const { outlet } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    changeDateGrossProfit(formattedStart, formattedEnd, outlet);
  };

  _onClickExport = reportType => {
    const {
      exportGrossProfit,
      search,
      outlets,
      outletComparisonEnabled,
    } = this.props;
    const { startDate, endDate, startHour, endHour, allDay } = search.date;
    const { outlet } = search;

    let outletIds = outlet;
    if (reportType === 'perOutlet') {
      outletIds = outlets && outlets.map(o => o.id);
    }

    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const filename = csvName(
      moment(formattedStart),
      moment(formattedEnd),
      'Report Gross Profit',
      outletIds,
      outlets,
      allDay
    );
    const query = {
      startDate: formattedStart,
      endDate: getFormattedEndDate(formattedEnd),
      timeZone: '',
    };
    const queryParams = {
      compareOutlet: outletComparisonEnabled,
    };

    if (outletIds.length > 1 && outletComparisonEnabled) {
      clevertapReportsGrossProfit.reportGrossProfitPerOutletExport({
        outletIds: outlet,
        startDate: formattedStart,
        endDate: formattedEnd,
      });
    } else {
      clevertapReportsGrossProfit.reportGrossProfitExport({
        outletIds: outlet,
        startDate: formattedStart,
        endDate: formattedEnd,
      });
    }

    exportGrossProfit(query, filename, outletIds, queryParams);
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const {
    showLoadingSpinnerReport,
    gross_profit: grossProfit,
  } = state.reports.grossProfit;
  return {
    outlets: state.actionBar.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    showLoadingSpinnerReport,
    grossProfit,
  };
}

const mapDispatchToProps = {
  grossProfitPageRequest,
  changeDateGrossProfit,
  changeOutletGrossProfit,
  exportGrossProfit,
};

function mapFlagsToProp(flags) {
  return {
    outletComparisonEnabled: flags.summaryPerOutlet,
  };
}

export default withFeatureFlags(mapFlagsToProp)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GrossProfit)
);
